import * as React from 'react';
import axios from 'axios';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import {destURL} from './../utils/Utils' 

import PreloaderAnim from './PreloaderAnim'


export default function RegelsComponent() {
  const [regels, setRegels] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    let u = destURL + "?regels=1"
    if(window.location.href.indexOf("dinsdaghakkers") > -1 )u = destURL + "?regels=1"
    axios.get(u)
      .then(res => {
        res.data.shift()
        let ta = []
        for(let i=0;i<res.data.length;i++){
          ta.push(res.data[i][0])
        }
        console.log(ta)
        setRegels(ta)
        setLoading(false)
      })
      .catch(err => {
        console.error('Fout bij ophalen regels:', err)
        setError('Kon de regels niet ophalen. Controleer je internetverbinding of probeer het later opnieuw.')
        setLoading(false)
      })
  },[]);

  return (
    <>
        <Toolbar />
        <h1>Huisregels</h1>
        {loading && <PreloaderAnim />}
        {error && (
          <div style={{padding: '20px', backgroundColor: '#ffebee', borderRadius: '8px', color: '#c62828', marginTop: '20px'}}>
            <strong>Fout:</strong> {error}
          </div>
        )}
        {!loading && !error && (
          <ul>
            {regels.map((item, i) => {
               return <li key={i} style={{
                 opacity: 0,
                 animation: 'rowSlideIn 0.4s ease-out forwards',
                 animationDelay: `${i * 0.08}s`
               }}>{item}</li>
             })}
          </ul>
        )}
    </>
  );
}